import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { contractAddress } from "../../config/BackendUrl";
import DynamicNFTCard from './DynamicCard';
import CardPlaceholder from './NFTCardPlaceholder';
import Pagination from '../Pagination';
import AllNFTsFilter from '../filters/AllNFTsfilters';
import { listNFTs } from '../../hooks/NFTHook';
import { Dropdown } from 'react-bootstrap';
import { handleApiError, retryApiCall } from '../../utils/apiUtils';

const HomeNFTs = (props) => {
  const [nfts, setNfts] = useState([]);
  const [hasMore, setHasMore] = useState(true);
  const [currentPage, setCurrentPage] = useState(0);
  const [limit, setLimit] = useState(props.length);
  const [isPagination, setIsPagination] = useState(false);
  const [pageCount, setPageCount] = useState(0);
  const [filter, setFilter] = useState("all");
  const [activeTab, setActiveTab] = useState("all");
  const [sortBy, setSortBy] = useState(null); // State for sorting
  const [listed, setListed] = useState(null); // State for listing status
  const userIds = localStorage.getItem("userId");


  const userWalletAddress = localStorage.getItem("WalletAddress");
  const location = useLocation();

  const fetchNFTs = async () => {
    try {
      const page = currentPage + 1;
      const Params = {
        page,
        limit,
        contractAddress,
        listed: true,
        category: activeTab !== "all" ? activeTab : undefined,
        sortBy: sortBy || undefined,
      };

      const updatedNFTs = await retryApiCall(
        () => listNFTs(Params),
        3,
        1000
      );

      if (updatedNFTs.success) {
        const NFTs = updatedNFTs.data;
        const AddIsLikeFlag = NFTs.map(item => {
          const isLike = item.likes.some(like =>
            like.userId === userIds
          );
          return { ...item, isLike };
        });

        setNfts(AddIsLikeFlag);
        setPageCount(updatedNFTs.totalPages);
        setHasMore(updatedNFTs.total > 0);

        if (location.pathname === "/profile" || location.pathname === "/allNFTs") {
          setIsPagination(updatedNFTs.totalPages > 1);
        }
      } else {
        throw new Error('Failed to fetch NFTs');
      }
    } catch (error) {
      handleApiError(error, 'Failed to load NFTs');
      setHasMore(false);
    }
  };

  const fetchUserNFTs = async () => {
    const page = currentPage + 1;
    const Params = {
      page,
      limit,
      sortBy,
      ownerAddress: userWalletAddress,
      // contractAddress,
      category: activeTab !== "all" ? activeTab : undefined,
      listed: true,
    };

    const userNFTs = await listNFTs(Params);

    if (userNFTs.success) {
      setTimeout(() => {
        setNfts(userNFTs.data);
        setPageCount(userNFTs.totalPages);
        setHasMore(userNFTs.total > 0);
      }, 2000);

      if (location.pathname === "/profile" || location.pathname === "/allNFTs") {
        setIsPagination(userNFTs.totalPages > 1);
      }
    }
  };

  // Fetch data based on location state and activeTab
  useEffect(() => {
    setHasMore(true);
    setNfts([]);
    if (location.state === "user") {
      fetchUserNFTs();
    } else {
      fetchNFTs();
    }
  }, [currentPage, activeTab, sortBy, listed]);

  const handleFilterChange = (filterKey) => {
    setFilter(filterKey);
    setCurrentPage(0); // Reset to first page
    setSortBy(null);
    setListed(null);

    if (filterKey === "latest") {
      setSortBy("createdAt");
    } else if (filterKey === "listed") {
      setListed(true);
    } else if (filterKey === "not listed") {
      setListed(false);
    }
  };
  const handlePageChange = (selectedItem) => {
    setNfts([]); // Clear NFTs for new page
    setCurrentPage(selectedItem.selected);
  };

  const renderCategoryContent = () => {
    switch (activeTab) {
      case "all":
        { CategortContentUI() }
      case "games":
        { CategortContentUI() }
      case "Art":
        { CategortContentUI() }
      case "tradingCards":
        { CategortContentUI() }
      case "music":
        { CategortContentUI() }
      case "domainNames":
        { CategortContentUI() }
      case "memes":
        { CategortContentUI() }
      case "collectibles":
        { CategortContentUI() }
      default:
        return nfts.length !== 0 ? (
          nfts.map((val, i) => (
            <div key={i} className="col-lg-3 col-md-4 col-sm-6 card-hover-effect">

              <DynamicNFTCard
                NFTLink={`/nftdetails/${val.contractAddress}/${val._id}`}
                contractAddress={val.contractAddress}
                currentOwnerPic={val?.currentOwner?.userId?.profilePicture}
                currentOwnerName={val?.currentOwner?.userId?.name}
                currentOwnerLink={val?.currentOwner?.walletAddress !== userWalletAddress ? `/otherProfile/${val?.currentOwner?.walletAddress}` : "/profile"}
                mediaUrl={val.imageUri}
                assetType={val.assetType}
                title={val.title}
                price={val.price}
                likes={val.totalLikes}
                isLiked={val.isLike}
                tokenId={val.tokenId}
                isListed={val.listed}
                nftId={val._id}
                type={val.type}
              />

            </div>
          ))
        ) : hasMore ? (
          <>
            {[...Array(limit)].map((_, index) => (
              <div className="col-lg-3 col-md-4 col-sm-6" key={index}>
                <CardPlaceholder />
              </div>
            ))}
          </>
        ) : (
          <h3>No NFTs Available</h3>
        );
    }
  };
  const CategortContentUI = () => {
    console.log("active TAB", activeTab);

    return nfts.length !== 0 ? (
      nfts.map((val, i) => (
        <div key={i} className="col-lg-3 col-md-4 col-sm-6 card-hover-effect">

          <DynamicNFTCard
            NFTLink={`/nftdetails/${val.contractAddress}/${val._id}`}
            contractAddress={val?.currentOwner?.walletAddress}
            currentOwnerPic={val?.currentOwner?.userId?.profilePicture}
            currentOwnerName={val?.currentOwner?.userId?.name}
            currentOwnerLink={val?.currentOwner?.walletAddress === userWalletAddress ? "/profile" : `/otherProfile/${val?.currentOwner?.walletAddress}`}
            creatorAddress={val.creator.walletAddress}
            creatorOwnerPic={val?.creator?.userId?.profilePicture}
            creatorOwnerName={val?.creator?.userId?.name}
            creatorOwnerLink={val.creator.walletAddress === userWalletAddress ? "/profile" : `/otherProfile/${val?.creator?.walletAddress}`}
            mediaUrl={val.uri}
            assetType={val.assetType}
            title={val.title}
            price={val.price}
            likes={val.totalLikes}
            isLiked={val.isLike}
            tokenId={val.tokenId}
            isListed={val.listed}
            nftId={val._id}
            creator={val.creator}
          />

        </div>
      ))
    ) : hasMore ? (
      <>
        {[...Array(limit)].map((_, index) => (
          <div className="col-lg-3 col-md-4 col-sm-6" key={index}>
            <CardPlaceholder />
          </div>
        ))}
      </>
    ) : (
      <h3>No NFTs Available</h3>
    );
  }
  console.log("NFTs", nfts, listed);

  return (
    <>
      {location.pathname.split('/')[1] === "allNFTs" &&
        <AllNFTsFilter activeTab={activeTab} setActiveTab={setActiveTab} />}
      <div className="mt-100">
        <div className="container">
          {location.pathname !== "/profile" && location.pathname !== "/allNFTs" && (
            <div className="section__head">
              <div className="d-flex space-x-20 justify-content-between align-items-center">
                <h2 className="section__title text-center">Explore</h2>
                <Link to="/marketplace" className="btn btn-sm btn-dark">View all</Link>
              </div>
            </div>
          )}
          {location.pathname === "/allNFTs" &&
            <div className='d-flex align-items-center justify-content-between'>
              <h2 className="section__title mb-20"> {location.state === "user" ? "User's" : "All"} NFT</h2>
              <Dropdown>
                <Dropdown.Toggle id="dropdown-basic">
                  Filter
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item onClick={() => handleFilterChange("all")}>All</Dropdown.Item>
                  <Dropdown.Item onClick={() => handleFilterChange("latest")}>Latest</Dropdown.Item>
                  <Dropdown.Item onClick={() => handleFilterChange("listed")}>Listed</Dropdown.Item>
                  <Dropdown.Item onClick={() => handleFilterChange("not listed")}>Not Listed</Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          }
          <div className="tab-content mt-4 container">
            <div className="row">
              {renderCategoryContent()}
            </div>
            {isPagination && (
              <Pagination
                pageCount={pageCount}
                onPageChange={handlePageChange}
                currentPage={currentPage}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default HomeNFTs;
